import cn from "classnames";
import { Button } from "shared/ui/Button";
import { TrashIcon } from "shared/ui/Icons/Icons";
import styles from "./DeleteAllButton.module.scss";

type DeleteAllButtonProps = {
  onClick: () => void;
};

export const DeleteAllButton: RFC<DeleteAllButtonProps> = ({ onClick }) => {
  return (
    <Button data-test-id="delete-all-button" onClick={onClick} className={cn(styles.button)}>
      <TrashIcon />
    </Button>
  );
};
